import { createContext, useCallback, useContext, useEffect, useState } from "react";
import api from "@/lib/api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(() => {
    try {
      const raw = localStorage.getItem("gnd_user");
      return raw ? JSON.parse(raw) : null;
    } catch {
      return null;
    }
  });
  const [checking, setChecking] = useState(Boolean(localStorage.getItem("gnd_token")));

  useEffect(() => {
    let cancelled = false;
    const token = localStorage.getItem("gnd_token");
    if (!token) {
      setChecking(false);
      return;
    }
    api
      .get("/auth/me")
      .then((r) => {
        if (cancelled) return;
        setUser(r.data);
        localStorage.setItem("gnd_user", JSON.stringify(r.data));
      })
      .catch(() => {
        if (cancelled) return;
        localStorage.removeItem("gnd_token");
        localStorage.removeItem("gnd_user");
        setUser(null);
      })
      .finally(() => {
        if (!cancelled) setChecking(false);
      });
    return () => {
      cancelled = true;
    };
  }, []);

  const login = useCallback(async (email, password) => {
    const r = await api.post("/auth/login", { email, password });
    localStorage.setItem("gnd_token", r.data.access_token);
    localStorage.setItem("gnd_user", JSON.stringify(r.data.user));
    setUser(r.data.user);
    return r.data.user;
  }, []);

  const logout = useCallback(() => {
    localStorage.removeItem("gnd_token");
    localStorage.removeItem("gnd_user");
    setUser(null);
  }, []);

  return (
    <AuthCtx.Provider value={{ user, checking, login, logout }}>{children}</AuthCtx.Provider>
  );
}

export function useAuth() {
  const ctx = useContext(AuthCtx);
  if (!ctx) throw new Error("useAuth must be used within AuthProvider");
  return ctx;
}
